import { render, staticRenderFns } from "./application-submitted.vue?vue&type=template&id=f592d22c"
import script from "./application-submitted.vue?vue&type=script&lang=js"
export * from "./application-submitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports